export default __webpack_public_path__ + "locales/lo-LA/WebPlugins.json?hash=91e5512d02df5759b7a35c990f79d224";